<template>
    <div>
        <!-- Loading spinner -->
        <div v-if="loading" class="text-center">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>

        <!-- Table of transactions -->
        <table v-if="transactions && transactions.length > 0" class="table table-striped bg-white border">
            <thead>
            <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Credits</th>
                <th>Notes</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="transaction in transactions" :key="transaction.id">
                <td>{{ transaction.createdAtFormatted }}</td>
                <td>
                    <template v-if="transaction.payment">
                        One-off credit purchase
                    </template>
                    <template v-else-if="transaction.course">
                        <a :href="transaction.course.uri">{{ transaction.course.name }}</a>
                    </template>
                    <template v-else-if="transaction.type == 'reward'">
                        Reward
                    </template>
                    <template v-else-if="transaction.subscription">
                        Subscription
                    </template>
                </td>
                <td :class="transaction.credits > 0 ? 'text-success' : 'text-danger'">
                    {{ transaction.credits }}
                </td>
                <td>{{ transaction.notes }}</td>
            </tr>
            </tbody>
        </table>

        <!-- Message for no transactions -->
        <p v-if="!loading && (!transactions || transactions.length === 0)">
            No transactions available.
        </p>
    </div>
</template>

<script>
export default {
    props: {
        userId: {
            type: Number,
            required: false
        }
    },
    data() {
        return {
            transactions: null,
            loading: false
        };
    },
    async mounted() {
        this.loading = true;
        let userId = this.userId ?? window.virtuoso.user.id;

        try {
            const response = await axios.get('/api/credit-transactions/' + userId);
            this.transactions = response.data;
        } catch (error) {
            console.error('Failed to fetch transactions:', error);
        } finally {
            this.loading = false;
        }
    }
}
</script>
